import React from "react";

import "./nav.css";

const Nav = () => {
  return (
    <nav className="navigator">
      <a href="#header" className="navigator__link">
        <i class="fas fa-chevron-circle-up"></i>
      </a>
    </nav>
  );
};

export default Nav;
